<template functional>
    <span
        class="VToggle"
        :class="{
            'VToggle_vertical-toggle': props.isVerticalToggle,
            'VToggle_vertical': props.isVertical,
        }"
    >
        <span
            class="VToggle__label"
        >{{ props.label }}</span>
        <span
            class="VToggle__switch"
            :class="{'VToggle__switch_active':props.checked}"
            @click="props.sync ? listeners.change(!props.checked) :listeners.click ? listeners.click() : null "
        >
        </span>
         <span
             class="VToggle__label-after"
         >{{ props.labelAfter }}</span>
    </span>
</template>

<script>
    export default {
        name: 'VToogle',
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            label: {
                type: String,
                default: '',
            },
            labelAfter: {
                type: String,
                default: '',
            },
            checked: {
                type: Boolean,
                required: true,
            },
            sync: {
                type: Boolean,
                default: false,
            },
            isVertical: {
                type: Boolean,
                default: false,
            },
            isVerticalToggle: {
                type: Boolean,
                default: false,
            },
        },
    };

</script>

<style
    scoped
    lang="scss"
>
    .VToggle {
        display: flex;
        align-items: center;
        
        &_vertical {
            flex-direction: column;
            justify-content: space-between;
        }
        
        &__label {
            font-size: 12px;
            margin-bottom: 6px;
            &-after {
                font-size: 12px;
                margin-left: 6px;
            }
        }
        
        &__switch {
            position: relative;
            display: inline-block;
            cursor: pointer;
            width: 34px;
            height: 20px;
            border: 1px solid $primary-color;
            border-radius: 34px;
            
            &:before {
                border-radius: 50%;
                height: 16px;
                width: 16px;
                left: 1px;
                bottom: 2px;
                position: absolute;
                content: "";
                background-color: $primary-color;
                -webkit-transition: .4s;
                transition: .4s;
            }
            
            &_active {
                background: $light-blue-color;
                
                &:before {
                    -webkit-transform: translateX(16px);
                    -ms-transform: translateX(16px);
                    transform: translateX(16px);
                    background-color: $primary-color;
                }
            }
        }
        &_vertical-toggle {
            flex-direction: column;
            justify-content: space-between;
            transform: rotate(90deg);
            margin-left: 5px;
        }
    }

</style>
